function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M7.4987 17.0007H14.9987C15.6904 17.0007 16.282 16.584 16.532 15.984L19.0487 10.109C19.1237 9.91732 19.1654 9.71732 19.1654 9.50065V7.83398C19.1654 6.91732 18.4154 6.16732 17.4987 6.16732H12.2404L13.032 2.35898L13.057 2.09232C13.057 1.75065 12.9154 1.43398 12.6904 1.20898L11.807 0.333984L6.31536 5.82565C6.01536 6.12565 5.83203 6.54232 5.83203 7.00065V15.334C5.83203 16.2507 6.58203 17.0007 7.4987 17.0007ZM7.4987 7.00065L11.1154 3.38398L9.9987 7.83398H17.4987V9.50065L14.9987 15.334H7.4987V7.00065ZM0.832031 7.00065H4.16536V17.0007H0.832031V7.00065Z",
  fill: "#3456FF"
});

function SvgIconLike(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 17,
    viewBox: "0 0 20 17",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLike);
export default __webpack_public_path__ + "static/media/icon-like.ddf13c8c.svg";
export { ForwardRef as ReactComponent };